import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const SIZE_MAP = { large: 25, medium: 14, small: 10 }
const CONTAINER_SIZE_MAP = { large: 31, medium: 24, small: 20 }

const BookmarkIcon = forwardRef(({ fontSize, ...props }, ref) => {
  const size = SIZE_MAP[fontSize] ?? SIZE_MAP.medium
  const containerSize = CONTAINER_SIZE_MAP[fontSize] ?? CONTAINER_SIZE_MAP.medium
  return (
    <S.IconContainer ref={ref} $size={containerSize} {...props}>
      <img src="/img/bookmark.svg" alt="Bookmark" width={size} height={size} />
    </S.IconContainer>
  )
})

BookmarkIcon.displayName = 'BookmarkIcon'

BookmarkIcon.propTypes = {
  fontSize: PropTypes.string
}

BookmarkIcon.defaultProps = {
  fontSize: 'medium'
}

export default BookmarkIcon

const S = {
  IconContainer: styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    flex-shrink: 0;
  `
}
